import { Dialog } from 'primereact/dialog';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { Text } from 'src/redesign/components/Text';
import { Loader } from 'wix-style-react';
import { closeAttendeeTicketsModal } from '../store/reducer';
import { isAttendeeTicketsModalVisibleSelector } from '../store/selectors';
import {
  attendeeTicketsSelector,
  attendeeTicketsLoadingSelector,
} from 'src/redesign/features/Attendees/store/selectors';
import { TicketCard } from './TicketCard';
import styles from './AttendeeTicketsModal.module.scss';

export const AttendeeTicketsModal = () => {
  const dispatch = useAppDispatch();
  const isVisible = useAppSelector(isAttendeeTicketsModalVisibleSelector);
  const tickets = useAppSelector(attendeeTicketsSelector);
  const isLoading = useAppSelector(attendeeTicketsLoadingSelector);

  const handleClose = () => {
    dispatch(closeAttendeeTicketsModal());
  };

  return (
    <Dialog
      visible={isVisible}
      onHide={handleClose}
      header="Your Tickets"
      style={{ width: '600px', maxHeight: '80vh' }}
      draggable={false}
      modal
    >
      <div className={styles.content}>
        <Text variation="body" color="black-400" className={styles.description}>
          Which ticket do you need help with or want to reach out to the host about?
        </Text>

        {isLoading ? (
          <div className={styles.loadingContainer}>
            <Loader size="small" />
          </div>
        ) : tickets && tickets.length > 0 ? (
          <div className={styles.ticketsList}>
            {tickets.map((ticket) => (
              <TicketCard key={ticket.cart_id} ticket={ticket} />
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <Text variation="body" color="black-400">
              You don't have any tickets yet
            </Text>
          </div>
        )}
      </div>
    </Dialog>
  );
};
